import React from 'react';

export const LogoutIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.656"
    height="16"
    viewBox="0 0 20.656 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M692,700.657l-1.456-1.456,3.395-3.2H684.5a0.5,0.5,0,0,1-.5-0.5v-1a0.5,0.5,0,0,1,.5-0.5h9.439l-3.395-3.2L692,689.343,697.657,695ZM687,689h-8v12h8v-4h2v5a1,1,0,0,1-1,1H678a1,1,0,0,1-1-1V688a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v5h-2v-4Z"
      transform="translate(-677 -687)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/logout-icon.js